module.exports = __webpack_public_path__ + "img/xzj-xcb-banner.4427e52b.jpg";